module.exports = __webpack_public_path__ + "static/img/co.th.promptpay.qr.65a3bc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bank_logo/co.th.promptpay.qr.svg
// module id = Yrg9
// module chunks = 27 28